import React, { useState, useEffect } from 'react';
import '../../css/seePartners.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoSearch } from "react-icons/io5";
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import adsOfferData from '../../mock/adsOffer.json'
import adsSecondOfferData from '../../mock/adsSecondOffer.json'
import CustomAlert from '../CustomAlert';
import CustomButton from '../CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import { setCategoryState } from '../../features/onboardingData/onboardingUserData';
import Slider from '../Sliders/Slider';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import useCodes from '../../hooks/useCodes';
import iconRestaurant from '../../assets/svg/iconRestaurant.svg';
import iconAccomodationTravel from '../../assets/svg/iconAccomodationTravel.svg';
import iconStore from '../../assets/svg/iconStore.svg';
import iconBeautyStore from '../../assets/svg/iconBeautyStore.svg';
import iconEducation from '../../assets/svg/iconEducation.svg';
import iconCultureLeisure from '../../assets/svg/iconCultureLeisure.svg';
import iconSport from '../../assets/svg/iconSport.svg';
import iconTech from '../../assets/svg/iconTech.svg';
import iconModaHome from '../../assets/svg/iconModaHome.svg';
import iconAnimals from '../../assets/svg/iconAnimals.svg';
import iconCarsTransp from '../../assets/svg/iconCarsTransp.svg';
import iconSustainability from '../../assets/svg/iconSustainability.svg';
import iconOther from '../../assets/svg/iconOther.svg';
import iconGPS from '../../assets/svg/gpsIcon.svg';

function SeePartners() {

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [swiperIndexTwo, setSwiperIndexTwo] = useState(0);
    const [swiperInstanceTwo, setSwiperInstanceTwo] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [seacrhCategory, setSeacrhCategory]  = useState('');
    const { getImageAdsNum } = useCodes();
    const [isFocused, setIsFocused] =  useState(false);
    const isCategoryState = useSelector((state) => state.onboardingUserData.isCategoryState);
    const dispatch = useDispatch();
    
    const handleShowInfo = () => {
        setModalShow(true)
    };

    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        setIsFocused(false);
    };

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const hadleBtnClickKnowMorePartners = () => {
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros');
    };

    const hadleBtnClickGoToPartners = (category) => {
        dispatch(setCategoryState(true));
        navigate('/ganhar-saldo/parceiros/catalogo-de-parceiros', { state: {category} });
    };

    const hadleBtnClickSearchPartners = () => {
        navigate("/ganhar-saldo/parceiros/catalogo-de-parceiros", { state: {seacrhCategory} });
    };

    const handleClickNextToMe = () => {
        const aroundMe = 5;
        navigate("/ganhar-saldo/parceiros/catalogo-de-parceiros", { state: {aroundMe} });
    };

    const handleSwiperSlideChangeTwo = (swiperTwo) => {
        setSwiperIndexTwo(swiperTwo.activeIndex);
    };

    const nextImageTwo = () => {
        if (swiperInstanceTwo !== null) {
            swiperInstanceTwo.slideNext();
        }
    };

    const prevImageTwo = () => {
        if (swiperInstanceTwo !== null) {
            swiperInstanceTwo.slidePrev();
        }
    };

    const navBlockData = [
        {
          "iconNavBlock": iconRestaurant,
          "titleNavBlock": "Restauração e Supermercados",
          "category": "Restauração e Supermercados"
        },
        {
          "iconNavBlock": iconAccomodationTravel,
          "titleNavBlock": "Alojamento e Viagens",
          "category": "Alojamento e Viagens"
        },
        {
          "iconNavBlock": iconBeautyStore,
          "titleNavBlock": "Saúde e Beleza",
          "category": "Saúde e Beleza"
        },
        {
          "iconNavBlock": iconEducation,
          "titleNavBlock": "Crianças e Educação",
          "category": "Crianças e Educação"
        },
        {
          "iconNavBlock": iconCultureLeisure,
          "titleNavBlock": "Cultura e Lazer",
          "category": "Cultura e Lazer"
        },
        {
          "iconNavBlock": iconSport,
          "titleNavBlock": "Desporto e Nutrição",
          "category": "Desporto e Nutrição"
        },
        {
          "iconNavBlock": iconTech,
          "titleNavBlock": "Tecnologia",
          "category": "Tecnologia"
        },
        {
          "iconNavBlock": iconModaHome,
          "titleNavBlock": "Moda e Casa",
          "category": "Moda e Casa"
        },
        {
          "iconNavBlock": iconAnimals,
          "titleNavBlock": "Animais",
          "category": "Animais"
        },
        {
          "iconNavBlock": iconCarsTransp,
          "titleNavBlock": "Mobilidade",
          "category": "Mobilidade"
        },
        {
          "iconNavBlock": iconSustainability,
          "titleNavBlock": "Sustentabilidade",
          "category": "Sustentabilidade"
        },
        {
          "iconNavBlock": iconOther,
          "titleNavBlock": "Outros",
          "category": "Outros"
        }
    ]

    const inputClassName = isTablet ? 'inputTextSeePartners': ( isMobile ? 'inputTextSeePartners' : 'inputTextSeePartnersMobile');
    const inputClassNameFocus = isTablet ? 'inputTextSeePartners focused': ( isMobile ? 'inputTextSeePartners focused' : 'inputTextSeePartnersMobile focused');

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.target.blur();
            hadleBtnClickSearchPartners();
        }
    };

    return (
        <>
        {/* Start search input */}
        <div className={isTablet ? 'searchViewContainerSeePartners' : ( isMobile ? 'searchViewContainerSeePartnersTablet' : 'searchViewContainerSeePartnersMobile')}>
                <div className='textWrapperSeePartners'>
                    { (isFocused || seacrhCategory.length > 0) &&
                        <label className='label-focusSeePartners'>Pesquise por parceiro ou localidade</label>
                    }
                    <input 
                        className={ seacrhCategory.length > 0 ? inputClassNameFocus : inputClassName}
                        type="text" 
                        placeholder={ !isFocused ? 'Pesquise por parceiro ou localidade' : undefined}
                        value={seacrhCategory}
                        onChange={(event) => setSeacrhCategory(event.target.value)}
                        maxLength={50}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                    />
                    <div className='findIconViewSeePartners' onClick={hadleBtnClickSearchPartners}><IoSearch className='findIconSeePartners' /></div>
                </div>
                <div className='searchGpsSelectViewContainerSeePartners' onClick={handleClickNextToMe}>
                    <div className='searchGpsSelectIconViewSeePartners'>
                        <img src={iconGPS} alt="icon" className='searchGpsSelectIconSeePartners'/>
                    </div>
                    <div className='searchGpsSelectTxtSeePartners'>Perto de mim</div>
                </div>
        </div>
        {/* End search input */}

        {/* Start partners list slider */}
        <div className={ isTablet ? 'mainPartnersListViewContainerSeePartners' : ( isMobile ? 'mainPartnersListViewContainerSeePartnersTablet' : 'mainPartnersListViewContainerSeePartnersMobile') }>
                <div className='txtAdsBoldSeePartners'>Parceiros por categoria</div>
            { isMobile ? (
                <div className='gridViewContainderBoldSeePartners'>
                    { navBlockData.map((block, index) => (
                    <button 
                        key={index} 
                        className={ isTablet ? 'navBoxViewContainerSeePartners' : 'navBoxViewContainerSeePartnersMobile' } 
                        onClick={() => hadleBtnClickGoToPartners(block.category)}>
                        <img src={block.iconNavBlock} alt="imagem" className="imagemNavBoxSvgSeePartners" />
                        <div className='txtNavBoxViewContainerSeePartners'>
                            <div className='txtNavBoxBoldSeePartners'>{block.titleNavBlock}</div>
                        </div>
                    </button>
                    ))}
                </div>
            ) : (
                <Swiper
                    slidesPerView={2}
                    spaceBetween={16}
                    // pagination={{
                    //     clickable: true,
                    //   }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    className="mySwiperThreeSeePartnersMobile"
                >
                    { navBlockData.map((block, index) => (
                        <SwiperSlide key={index}>
                            <button 
                                key={index} 
                                className={ isTablet ? 'navBoxViewContainerSeePartners' : 'navBoxViewContainerSeePartnersMobile' } 
                                onClick={() => hadleBtnClickGoToPartners(block.category)}>
                                <img src={block.iconNavBlock} alt="imagem" className="imagemNavBoxSvgSeePartners" />
                                <div className='txtNavBoxViewContainerSeePartners'>
                                    <div className='txtNavBoxBoldSeePartners'>{block.titleNavBlock}</div>
                                </div>
                            </button>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
        {/* End partners list slider */}

        {/* Start first slider */}
        <div className={isTablet ? 'mainSecondViewContainerSeePartners' : ( isMobile ? 'mainSecondViewContainerSeePartnersTablet' : 'mainSecondViewContainerSeePartnersMobile')}>

            {/* Start slider */}
            <Slider
                listRespData={adsOfferData.offerAds}
                getImage={getImageAdsNum}
            />
            {/* End slider */}

        </div>
        {/* End first slider */}

        {/* Start second slider */}
        {/* <div className={isTablet ? 'mainSecondViewContainerSeePartners' : ( isMobile ? 'mainSecondViewContainerSeePartnersTablet' : 'mainSecondViewContainerSeePartnersMobile')}>
            <div className='firstSubMainContainerSeePartners'>
                <div className='secondTitleViewSeePartners'>
                    <span className={isTablet ? 'textTitleRegular400SeePartners' : 'textTitleRegular400SeePartnersMobile'}> <b className={isTablet ? 'textTitleBold700SeePartners' : 'textTitleBold700SeePartnersMobile'}>Bebé e Gravidez:</b> nova categoria</span>
                </div>
                <div className='txtSecondTitleViewSeePartners'>
                    <span className={isTablet ? 'textSecondTitleViewSeePartners' : 'textSecondTitleViewSeePartnersMobile'}>Conheça as novidades do catálogo de parceiros Carteira Virtual Médis.</span>
                </div>
            </div> */}

            {/* Start slider */}
            {/* <Slider
                listRespData={adsOfferData.offerAds}
                getImage={getImageAdsNum}
            /> */}
            {/* End slider */}

        {/* </div> */}
        {/* End second slider */}

        {/* Start thied slider */}
            {/* <div className={isTablet ? 'mainThirdViewContainerSeePartners' : (isMobile ? 'mainThirdViewContainerSeePartnersTablet' : 'mainThirdViewContainerSeePartnersMobile')}>
                <div className={isTablet ? 'thirdTitleViewContainerSeePartners' : (isMobile ? 'thirdTitleViewContainerSeePartnersTablet' : 'thirdTitleViewContainerSeePartnersMobile')}>
                    <div className='thirdTitleViewSeePartners'>
                        <div className={isTablet ? 'thirdTextTitleBold700SeePartners' : 'thirdTextTitleRegular400SeePartners'}>Como funciona?</div>
                    </div>
                    <div className='txtThirdTitleViewSeePartners'>
                        <div className='thirdTextOneSeePartners'>Faça compras nos parceiros Carteira Virtual e receba parte do valor em saldo.</div>
                    </div>
                    <div className={isTablet ? 'divBtnKnowMorePartnersSeePartners' : 'divBtnKnowMorePartnersSeePartnersMobile'}>
                        <CustomButton
                            text={'Descobrir parceiros'}
                            textColor={'#141414'}
                            borderColor={'#141414'}
                            onPress={hadleBtnClickKnowMorePartners}
                            hasShadow={false}
                        />
                    </div>
                </div>

                <div className={isTablet ? 'secondSliderAdsContainerSeePartners' : (isMobile ? 'secondSliderAdsContainerSeePartnersTablet' : 'secondSliderAdsContainerSeePartnersMobile')}>
                    <Swiper
                        onSlideChange={(swiperTwo) => handleSwiperSlideChangeTwo(swiperTwo)}
                        onSwiper={(swiperTwo) => setSwiperInstanceTwo(swiperTwo)}
                        slidesPerView={isTablet ? 2.2 : 1}
                        spaceBetween={32}
                        modules={[Pagination]}
                        className={isTablet ? "mySwiperTwoSeePartners" : "mySwiperTwoSeePartnersMobile"}
                    >
                        {adsSecondOfferData.secondOfferAds.map((ad, index) => (
                            <SwiperSlide key={index}>
                                <div className={isTablet ? 'secondSliderAdsOfertaSeePartners' : 'secondSliderAdsOfertaSeePartnersMobile'}>

                                    <div className='txtTitleBoldAdsOfferTwoSeePartnersTwo'>{ad.title}</div>
                                    <div className='txtTitleAdsOfferTwoSeePartnersTwo'>{ad.storeName}</div>
                                    <div className='txtTitleAdsOfferTwoSeePartnersTwo'>{ad.description}</div>
                                    <div className='txtTitleRowViewAdsOfferTwoSeePartnersTwo'>
                                        <div className='txtCashbackAdsOfferTwoSeePartnersTwo'>
                                            <div className='iconTitleAdsOfferTwoSeePartnersTwo'><GoDotFill /></div>
                                            <div className='txtTitleAdsOfferTwoSeePartnersTwo'>{ad.cashback}</div>
                                            <button className='infoHeaderIonBtnAdsOfferTwoSeePartnersTwo' type='button' onClick={handleShowInfo} >
                                                <IoMdInformationCircleOutline className='infoHeaderIcondsOfferTwoSeePartnersTwo' />
                                            </button>
                                        </div>
                                        <div className='txtCashbackAmountAdsOfferTwoSeePartnersTwo'>
                                            <div className='txtTitleBoldAdsOfferTwoSeePartnersTwo'>{ad.cashbackAmount}</div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <CustomAlert
                        title='Tem dúvidas?'
                        text='Contacte-nos pelo geral@saude360.medis.pt ou através do 210 204 887 (dias úteis, das 9h às 18h).'
                        type='info'
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                    />

                    <div className={isTablet ? 'thirdSubMainContainerCircleNavSeePartners' : 'thirdSubMainContainerSeePartnersMobile'}>
                        <button className='iconArrowLeftViewContainerCircleNavSeePartners' onClick={prevImageTwo} disabled={swiperIndexTwo == 0}>
                            <FaArrowLeftLong className='iconArrowCircleNavSeePartners' />
                        </button>

                        <div className='cirlceSelectedNavSeePartners'>
                            <div className='circleMainvViewNavSeePartners'>
                                <div className='circleContainerNavSeePartners'>
                                    <div className={swiperIndexTwo == 0 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                </div>
                                <div className='circleContainerNavSeePartners'>
                                    <div className={swiperIndexTwo == 1 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                </div>
                                <div className='circleContainerNavSeePartners'>
                                    <div className={swiperIndexTwo >= 2 ? 'circleSelectedViewNavSeePartners' : 'circleViewNavSeePartners'} />
                                </div>
                            </div>
                        </div>

                        <button className='iconArrowRightViewContainerCircleNavSeePartners' onClick={nextImageTwo} disabled={swiperIndexTwo >= adsSecondOfferData.secondOfferAds.length - 2}>
                            <FaArrowRightLong className='iconArrowCircleNavSeePartners' />
                        </button>
                    </div>

                </div>

            </div> */}
        {/* End thied slider */}
        </>
    )
}

export default SeePartners